import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";

// Modal Video 
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import SectionTitle from "../../components/Shared/section-title";
import Tutorials from "./tutorials";

//Import Images
import gettingStarted from "../../images/onepage/thumbnails/1.png";
import setupDesktopApp from "../../images/onepage/thumbnails/2.png";
import setupMT4 from "../../images/onepage/thumbnails/3.png";
// import testTelegramChannel from "../../images/onepage/thumbnails/4.png";
// import testMT4TradingActions from "../../images/onepage/thumbnails/5.png";

class ModalVideoSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this);
    }

    tutorials = [
        {
            thumbnail: gettingStarted, 
            videoId: 'Spa0nddJnjg'
        },
        {
            thumbnail: setupDesktopApp, 
            videoId: 'Spa0nddJnjg'
        },
        {
            thumbnail: setupMT4, 
            videoId: 'iNYxkxVuQhE'
        }
    ]

    openModal() {
        this.setState({ isOpen: true })
    }

    render() {
        return (
            <React.Fragment>
                <Container className="mt-60">
                    <Row>
                        <Col xs="12">
                            <SectionTitle title="Watch the video series on installation and configuring" desc="Please download the demo for the step by step guidline."/>
                            <Tutorials tutorials={this.tutorials}/>
                        </Col>
                    </Row>
                </Container>
            </React.Fragment>
        );
    }
}

export default ModalVideoSection;